import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'store/index';
import './index.scss';

const container = document.getElementById('dialog');

export interface DialogProps {
  className?: string;
  title?: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
  mask?: boolean;
  handleClose: () => void;
}

const Dialog: React.FC<DialogProps> = (props) => {
  const { className, title, content, footer, mask, handleClose } = props;
  return (
    <div className="dialog-container">
      {mask && <div className="mask" onClick={handleClose} />}

      <div className={`dialog ${className}`}>
        {title && (
          <div className="text-bold header">
            {title}
            <span className="close" role="button" onClick={handleClose} />
          </div>
        )}
        <div className="content">{content}</div>
        {footer}
      </div>
    </div>
  );
};

Dialog.defaultProps = {
  mask: true,
};

export const showDialog = (props: Omit<DialogProps, 'handleClose'>) => {
  ReactDOM.render(
    <Provider store={store}>
      <Dialog {...props} handleClose={hideDialog} />
    </Provider>,
    container
  );
};

export const hideDialog = () => {
  ReactDOM.unmountComponentAtNode(container);
};
